module.exports = __webpack_public_path__ + "static/media/cross.3601f5c6.svg";